import React from 'react'
import { Link } from 'react-router-dom'
import '../css/notFound.css'
import { useContext } from 'react'
import { api } from '../api'

const NotFound = () => {
  const { t, language } = useContext(api)
  return (
    <main className="notFoundMain" style={language === 'ar' ? {direction: "rtl"} : {direction: "ltr"}}>
      <h1>{t("error404")}</h1>
      <h2>{t("error404Title")}</h2>
      <p>{t("error404Description")}</p>
      <Link to="/" className="homeLink">{t("error404HomeLink")}</Link>
    </main>
  )
}

export default NotFound